import React from "react";
import styles from "./DashboardHeader.module.scss";
import { IoNotificationsOutline, IoPersonOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getEnvironment } from "../../utils/environment";

export default function DashboardHeader() {
  const { userName } = useSelector((state) => state.user);
  const { PRODUCT } = getEnvironment();
  const navigate = useNavigate();
  const location = useLocation();
  const isProfilePage = location.pathname === "/profile" || location.pathname === "/profile/";
  return (
    <header className={styles.dashboard__header}>
      <div className={styles.brand__info}>
        <div className={styles.logo}>
          {/* <img src={PRODUCT === "ramfincorp_api" ? "/images/small-logo.png" : "/images/small-logo2.png"} alt="" /> */}
          {(PRODUCT === "ramfincorp_api" && isProfilePage) || isProfilePage ? (
            <div className="back-button" onClick={() => navigate("/dashboard")}>
              <img src="/images/back_icon.svg" className="back-icon" alt="Back" />
            </div>
          ) : PRODUCT === "ramfincorp_api" ? (
            <img src="/images/small-logo.png" alt="" />
          ) : (
            <img src="/images/small-logo2.png" alt="" />
          )}

        </div>
        <div className={styles.brand__name}>Hi, {userName ? userName.split(" ")[0].toLowerCase() : "Welcome"}{" "} </div>
      </div>
      {PRODUCT === "ramfincorp_api" ? 
      <div className={styles.profile}>
        <IoPersonOutline
          className={styles.profile_icon}
          onClick={() => navigate("/profile")}
        />
      </div>
      :null}
    </header>
  );
}
